module.exports = __webpack_public_path__ + "img/img1.2cf165c9.svg";